import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPageBySlug, getCollection } from "../lib/cms";
import ContactForm from "../components/ContactForm";
import { 
  Check, 
  Shield, 
  Award, 
  Users, 
  Car, 
  BookOpen, 
  ArrowRight, 
  ArrowUpRight, 
  ChevronLeft, 
  ChevronRight, 
  Facebook, 
  MapPin, 
  Heart, 
  Sparkles, 
  Clock, 
  Smile,
  CheckCircle2
} from "lucide-react";

const PARTNERS = [
  {
    title: "Sikker Trafik",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-sikker-trafik.png",
    link: "https://www.sikkertrafik.dk/rad-og-viden/bil/korekort/korekort-til-17-arige/",
    isLogo: true,
    isExternal: true,
    description: "Læs mere om reglerne for kørekort til 17-årige på Rådet for Sikker Trafiks hjemmeside."
  },
  {
    title: "Aalborg Pirates",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-pirates.png",
    link: null,
    isLogo: true,
    isExternal: false,
    description: "Carinas Køreskole sponsorerer Aalborg Pirates."
  },
  {
    title: "Gug Boldklub",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-gug.png",
    link: null,
    isLogo: true,
    isExternal: false,
    description: "Carinas Køreskole sponsorerer Gug Boldklub med 250 kroner pr. elev som kommer fra klubben."
  },
  {
    title: "Gavekort",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-gavekort.jpg",
    link: "/kontakt",
    isLogo: false,
    isExternal: false,
    description: "Køb et gavekort til et kørekort hos Carinas Køreskole. Ring 3051 7269 eller send en mail til carinaskoereskole@gmail.com."
  },
  {
    title: "Fart & Lovgivning",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-fart.jpg",
    link: "https://www.sikkertrafik.dk/rad-og-viden/bil/fart/?id=16437&gclid=EAIaIQobChMI9suil8C-5QIVBomyCh1TrQI1EAAYASAAEgLJRfD_BwE#16437",
    isLogo: false,
    isExternal: true,
    description: "FARTEN DRÆBER\nHar du kørt for stærkt? Beregn din bøde her."
  },
  {
    title: "EH Aalborg",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-ehaalborg-logo.png",
    link: null,
    isLogo: true,
    isExternal: false,
    description: "Carinas Køreskole sponsorerer EH Aalborg Ungdom."
  },
  {
    title: "Drive4you",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-drive4you-edited.jpg",
    link: "https://drive4you.dk/praktisk-proeve/",
    isLogo: true,
    isExternal: true,
    description: "Her kan du øve the praktiske prøve helt gratis."
  },
  {
    title: "Dansk Kørelærerunion",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-13-dansk-koerelaererunion.png",
    link: "http://aank.dk/det-goer-vi",
    isLogo: true,
    isExternal: true,
    description: "Carinas Køreskole er medlem af Dansk Kørelærer-Union."
  },
  {
    title: "Persondata & GDPR",
    image: "https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=80,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/imgi-10-gdpr.jpg",
    link: "/persondata",
    isLogo: false,
    isExternal: false,
    description: "Sådan behandler vi dine persondata"
  }
];

const getOptimizedUrl = (url, width = 600) => {
  if (!url || !url.includes("assets.auxodev.dk")) return url;
  if (url.includes("/cdn-cgi/image/")) return url;
  return url.replace("assets.auxodev.dk/", `assets.auxodev.dk/cdn-cgi/image/width=${width},quality=85,format=auto/`);
};

export default function Forside() {
  const [pageData, setPageData] = useState(null);
  const [prices, setPrices] = useState([]);
  const [passedStudents, setPassedStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(4);
  const [isPaused, setIsPaused] = useState(false);

  const [studentIndex, setStudentIndex] = useState(0);
  const [studentVisibleSlides, setStudentVisibleSlides] = useState(4);
  const [studentIsPaused, setStudentIsPaused] = useState(false);
  const [studentIsTransitioning, setStudentIsTransitioning] = useState(true);

  useEffect(() => {
    const updateVisibleSlides = () => {
      if (window.innerWidth < 640) {
        setVisibleSlides(1);
      } else if (window.innerWidth < 1024) {
        setVisibleSlides(2);
      } else if (window.innerWidth < 1280) {
        setVisibleSlides(3);
      } else if (window.innerWidth < 1440) {
        setVisibleSlides(4);
      } else {
        setVisibleSlides(5);
      }
    };
    updateVisibleSlides();
    window.addEventListener("resize", updateVisibleSlides);
    return () => window.removeEventListener("resize", updateVisibleSlides);
  }, []);

  useEffect(() => {
    const updateStudentVisibleSlides = () => {
      if (window.innerWidth < 640) {
        setStudentVisibleSlides(1);
      } else if (window.innerWidth < 1024) {
        setStudentVisibleSlides(2);
      } else {
        setStudentVisibleSlides(3);
      }
    };
    updateStudentVisibleSlides();
    window.addEventListener("resize", updateStudentVisibleSlides);
    return () => window.removeEventListener("resize", updateStudentVisibleSlides);
  }, []);

  useEffect(() => {
    const maxIndex = Math.max(0, PARTNERS.length - visibleSlides);
    if (currentIndex > maxIndex) {
      setCurrentIndex(maxIndex);
    }
  }, [visibleSlides, currentIndex]);

  // Initialize studentIndex to passedStudents.length when data loads
  useEffect(() => {
    if (passedStudents.length > 0) {
      setStudentIsTransitioning(false);
      setStudentIndex(passedStudents.length);
    }
  }, [passedStudents]);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      const maxIdx = Math.max(0, PARTNERS.length - visibleSlides);
      setCurrentIndex((prev) => (prev >= maxIdx ? 0 : prev + 1));
    }, 5000); // Slow autoplay every 5 seconds
    return () => clearInterval(interval);
  }, [visibleSlides, isPaused]);

  const nextStudentSlide = () => {
    if (!studentIsTransitioning || passedStudents.length === 0) return;
    setStudentIndex((prev) => prev + 1);
  };

  const prevStudentSlide = () => {
    if (!studentIsTransitioning || passedStudents.length === 0) return;
    setStudentIndex((prev) => prev - 1);
  };

  useEffect(() => {
    if (studentIsPaused || passedStudents.length <= studentVisibleSlides) return;
    const interval = setInterval(() => {
      nextStudentSlide();
    }, 6000); // Autoplay every 6 seconds
    return () => clearInterval(interval);
  }, [studentVisibleSlides, studentIsPaused, passedStudents, studentIsTransitioning]);

  const handleStudentTransitionEnd = () => {
    const N = passedStudents.length;
    if (N === 0) return;

    if (studentIndex >= N * 2) {
      setStudentIsTransitioning(false);
      setStudentIndex(studentIndex - N);
    } else if (studentIndex < N) {
      setStudentIsTransitioning(false);
      setStudentIndex(studentIndex + N);
    }
  };

  useEffect(() => {
    if (!studentIsTransitioning) {
      const raf = requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setStudentIsTransitioning(true);
        });
      });
      return () => cancelAnimationFrame(raf);
    }
  }, [studentIsTransitioning]);

  useEffect(() => {
    async function loadData() {
      try {
        const page = await getPageBySlug("index");
        const priceItems = await getCollection("prices");
        const students = await getCollection("passed_students");
        setPageData(page);
        setPrices(priceItems);
        setPassedStudents(students || []);
      } catch (err) {
        console.error("Error loading home page data:", err);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  useEffect(() => {
    if (pageData) {
      document.title = pageData.title;
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) {
        metaDesc.setAttribute("content", pageData.meta_description || "");
      }
    }
  }, [pageData]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-light">
        <div className="animate-pulse text-brand-primary font-bold text-lg">Henter indhold...</div>
      </div>
    );
  }

  // Advantages list
  const advantages = [
    {
      icon: Users,
      title: "Små teorihold (max. 8 elever)",
      desc: "Vi prioriterer små hold med vægt på den enkelte elevs behov, så der er god tid til alle. Her drukner du ikke i mængden.",
    },
    {
      icon: Car,
      title: "Kør i en lækker Audi Q3",
      desc: "Sikkerhed og komfort er helt i top i vores moderne Audi Q3. Du sidder højt, har fantastisk udsyn og føler dig tryg.",
    },
    {
      icon: Shield,
      title: "Tryg & personlig undervisning",
      desc: "Undervisningen tilrettelægges efter dig, så du føler dig helt tryg og klar til trafikken. 100% tålmodighedsgaranti.",
    },
    {
      icon: Award,
      title: "Medlem af Dansk Kørelærer-Union",
      desc: "Din garanti for en professionel og godkendt køreuddannelse efter alle gældende regler og love.",
    },
    {
      icon: BookOpen,
      title: "Nu også med automatgear",
      desc: "Tag dit kørekort i vores moderne elbil (VW ID.3) med automatgear (nye lempelige regler) for en endnu nemmere køreoplevelse.",
    },
    {
      icon: Check,
      title: "Gratis ekstra kørelektion",
      desc: "Tilmeld dig sammen med en ven, og I får begge en ekstra GRATIS kørelektion hver (værdi 695 kr.) oveni jeres lovpakke.",
    },
  ];

  const maxIndex = Math.max(0, PARTNERS.length - visibleSlides);
  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };
  const prevSlide = () => {
    setCurrentIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <div className="bg-brand-light">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-16 lg:py-24 border-b border-stone-200 bg-gradient-to-b from-white to-brand-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
            {/* Hero Text */}
            <div className="lg:col-span-7 space-y-6 text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider">
                <span className="h-2 w-2 rounded-full bg-brand-primary animate-pulse" />
                Køreskole i Gug, Aalborg SØ
              </div>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-brand-dark leading-tight tracking-tight">
                Tag dit kørekort hos <span className="text-brand-primary">Carinas Køreskole</span>
              </h1>
              <p className="text-stone-600 text-base sm:text-lg max-w-2xl mx-auto lg:mx-0 leading-relaxed">
                Hos Carinas Køreskole i Gug ønsker vi at uddanne gode, trafiksikre bilister med vægt på sikkerhed og god trafikadfærd. Vi prioriterer små hold med max 8 elever, så der er fuld fokus på dig og dine behov.
              </p>

              <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4 pt-4">
                <Link
                  to="/kontakt#tilmelding-form"
                  className="px-8 py-4 bg-brand-primary text-white text-base font-bold rounded-xl shadow-lg hover:bg-brand-primary-hover hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
                >
                  Tilmeld dig holdstart
                  <ArrowRight className="h-5 w-5" />
                </Link>
                <Link
                  to="/priser"
                  className="px-8 py-4 bg-white text-brand-dark border border-stone-200 text-base font-bold rounded-xl shadow-sm hover:bg-stone-50 hover:border-stone-300 transition-all duration-200 text-center"
                >
                  Se priser & rater
                </Link>
              </div>
              <div className="pt-2 text-xs text-stone-500 font-medium">
                Du kan starte på kørekortet allerede 3 måneder før du fylder 17 år.
              </div>
            </div>

            {/* Hero Image Stack */}
            <div className="lg:col-span-5 relative flex items-center justify-center">
              <div className="relative w-full max-w-md lg:max-w-none aspect-[4/3] sm:aspect-[4/3] lg:aspect-square">
                {/* Main Image: Audi Q3 Skolevogn */}
                <div className="absolute inset-0 rounded-3xl overflow-hidden border-4 border-white shadow-2xl z-10 bg-stone-100">
                  <img
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/9a7044-321b9f7c775a4e86a5b9f48c2a0bac79-mv2.jpg"
                    alt="Audi Q3 Skolevogn - Carinas Køreskole Gug"
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Overlapping Image: Carina Svensson */}
                <div className="absolute -bottom-6 -left-6 w-36 h-36 sm:w-44 sm:h-44 rounded-full overflow-hidden border-4 border-white shadow-xl z-20 bg-stone-100">
                  <img
                    src="https://assets.auxodev.dk/cdn-cgi/image/width=300,quality=85,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/mig.jpg"
                    alt="Kørelærer Carina Svensson"
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Floating Badge */}
                <div className="absolute -top-4 -right-4 bg-brand-secondary text-brand-dark font-black text-xs px-4 py-2.5 rounded-2xl shadow-lg rotate-6 flex items-center gap-1.5 border-2 border-white z-20 animate-float-slow">
                  <Smile className="h-4 w-4 text-brand-primary" />
                  <span>Tryg start i Gug!</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Facts Grid */}
      <section className="py-8 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center gap-4 p-4 rounded-2xl bg-brand-light border border-stone-100">
              <div className="h-12 w-12 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                <Users className="h-6 w-6" />
              </div>
              <div>
                <h4 className="font-bold text-brand-dark text-sm">Små hold (Max 8)</h4>
                <p className="text-stone-500 text-xs mt-0.5">Hyggelig stemning, plads til spørgsmål og kolde sodavand.</p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 rounded-2xl bg-brand-light border border-stone-100">
              <div className="h-12 w-12 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                <MapPin className="h-6 w-6" />
              </div>
              <div>
                <h4 className="font-bold text-brand-dark text-sm">Teorilokale i Gug</h4>
                <p className="text-stone-500 text-xs mt-0.5">Gugvej 186 D – nemt at komme til med bus nr. 15 lige til døren.</p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 rounded-2xl bg-brand-light border border-stone-100">
              <div className="h-12 w-12 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                <Car className="h-6 w-6" />
              </div>
              <div>
                <h4 className="font-bold text-brand-dark text-sm">Moderne biler</h4>
                <p className="text-stone-500 text-xs mt-0.5">Kør i vores Audi Q3 (manuel) eller VW ID.3 (automatgear).</p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 rounded-2xl bg-brand-light border border-stone-100">
              <div className="h-12 w-12 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                <Sparkles className="h-6 w-6" />
              </div>
              <div>
                <h4 className="font-bold text-brand-dark text-sm">Venne-rabat</h4>
                <p className="text-stone-500 text-xs mt-0.5">Tilmeld dig med en ven og få en ekstra GRATIS kørelektion hver.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-16 lg:py-24 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
              Dine fordele
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight mb-4">
              Hvorfor vælge Carinas Køreskole?
            </h2>
            <p className="text-stone-600 text-base sm:text-lg leading-relaxed">
              Vi gør alt for, at du får en tryg, lærerig og sjov oplevelse, når du skal tage dit kørekort. Her er nogle af vores største fordele:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {advantages.map((adv, index) => {
              const IconComp = adv.icon;
              return (
                <div
                  key={index}
                  className="bg-brand-light border border-stone-200/60 p-6 sm:p-8 rounded-2xl hover:shadow-md hover:-translate-y-1 transition-all duration-300 space-y-4 group"
                >
                  <div className="inline-flex items-center justify-center h-12 w-12 rounded-xl bg-brand-primary/10 text-brand-primary group-hover:bg-brand-primary group-hover:text-white transition-colors duration-300">
                    <IconComp className="h-6 w-6" />
                  </div>
                  <h3 className="text-lg font-bold text-brand-dark">{adv.title}</h3>
                  <p className="text-stone-600 text-sm leading-relaxed">{adv.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Modern Price Preview */}
      <section className="py-16 lg:py-24 bg-brand-light border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
              Priser & Pakker
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight mb-4">
              Overskuelige priser uden skjulte gebyrer
            </h2>
            <p className="text-stone-600 text-base sm:text-lg leading-relaxed">
              Vi tror på fuld gennemsigtighed. Her er prisen på vores mest populære pakker, præcis som du finder dem på vores prisside.
            </p>
          </div>

          {/* Price Cards Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-stretch">
            {prices.slice(0, 3).map((pkg) => (
              <div
                key={pkg.id || pkg.title}
                className={`bg-white border rounded-3xl p-6 sm:p-8 flex flex-col justify-between shadow-sm hover:shadow-lg transition-all duration-300 ${
                  pkg.title === "Lovpakken"
                    ? "border-brand-primary ring-4 ring-brand-primary/10 relative"
                    : "border-stone-200"
                }`}
              >
                {pkg.title === "Lovpakken" && (
                  <span className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-brand-primary text-white text-xs font-bold uppercase tracking-wider rounded-full shadow">
                    Mest populær
                  </span>
                )}
                <div className="space-y-6">
                  <div>
                    <h3 className="text-xl font-bold text-brand-dark mb-1">{pkg.title}</h3>
                    <p className="text-stone-500 text-xs font-medium">{pkg.subtitle}</p>
                  </div>
                  <div className="border-y border-stone-100 py-4">
                    <span className="text-3xl sm:text-4xl font-black text-brand-primary block">{pkg.price}</span>
                    {pkg.title === "Lovpakken" && (
                      <span className="text-xs text-stone-500 font-medium mt-1 block">Betales i 2 rater</span>
                    )}
                  </div>
                  <div className="space-y-4">
                    <h4 className="text-xs font-bold uppercase tracking-wider text-stone-400">Hvad er inkluderet:</h4>
                    <div
                      className="text-stone-600 text-sm space-y-2 prose-ul:list-disc prose-ul:pl-4 prose-li:mb-1.5"
                      dangerouslySetInnerHTML={{ __html: pkg.included }}
                    />
                  </div>
                </div>
                <div className="pt-8 mt-6 border-t border-stone-100">
                  <Link
                    to="/priser"
                    className={`block w-full text-center py-3 px-4 rounded-xl text-sm font-bold transition-all duration-200 ${
                      pkg.title === "Lovpakken"
                        ? "bg-brand-primary text-white hover:bg-brand-primary-hover shadow-md"
                        : "bg-stone-50 text-brand-dark hover:bg-stone-100 border border-stone-200"
                    }`}
                  >
                    Se alle detaljer & udgifter
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/priser"
              className="inline-flex items-center gap-2 text-brand-primary font-bold hover:text-brand-primary-hover transition-colors"
            >
              Se alle vores priser, BE-kørekort og rutinetimer
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Safe and Personal Driving Lessons Section */}
      <section className="py-16 lg:py-24 bg-white border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            {/* Left Column: Image */}
            <div className="lg:col-span-5 order-last lg:order-first">
              <div className="relative">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/8426b648-fe3a-4547-bb02-98fcf24d83ce/billede-af-mig-selv.jpg"
                  alt="Kørelærer Carina Svensson"
                  className="rounded-3xl shadow-xl w-full h-[450px] object-cover border border-stone-200"
                />
                <div className="absolute -bottom-6 -right-6 bg-brand-secondary text-brand-dark p-6 rounded-2xl shadow-lg max-w-xs border border-amber-400 hidden sm:block">
                  <p className="text-xs font-bold uppercase tracking-wider mb-1">Erfaren kørelærer</p>
                  <p className="text-sm font-semibold leading-relaxed">
                    Carina Svensson har drevet egen køreskole i Gug siden august 2019.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Text */}
            <div className="lg:col-span-7 space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider">
                Tryghed i højsædet
              </div>
              <h2 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight">
                Tryg og personlig køreundervisning
              </h2>

              <div className="text-stone-600 space-y-4 leading-relaxed">
                <p>
                  Hos Carinas Køreskole er du ikke bare et nummer i rækken. Vi ved, at det kan være spændende og måske lidt grænseoverskridende at skulle køre bil for første gang. Derfor tilrettelægger vi undervisningen og køretimerne efter den enkelte elevs behov, så alle føler sig trygge.
                </p>
                <p>
                  Vi prioriterer et positivt undervisningsmiljø med godt humør og gensidig respekt. Det danner nemlig det absolut bedste grundlag for læring.
                </p>
                <p>
                  Vores teorilokale på Gugvej 186 D er indrettet med fokus på et godt fysisk læringsmiljø, hvor du føler dig tilpas i omgivelserne. Og med max. 8 personer på holdet er der altid god tid til spørgsmål og dialog.
                </p>
              </div>
              <div className="pt-4">
                <Link
                  to="/om-carina"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-brand-dark text-white text-sm font-bold rounded-xl hover:bg-stone-800 transition-all duration-200"
                >
                  Læs mere om bilerne & Carina
                  <ArrowRight className="h-4 w-4 text-brand-secondary" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partners & Recommendations Section */}
      <section className="py-20 lg:py-28 bg-white border-b border-stone-200 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
            Samarbejde
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-normal text-brand-dark tracking-tight">
            Samarbejdspartnere & anbefalinger
          </h2>
        </div>

        <div 
          className="relative w-full"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {/* Carousel track wrapper */}
          <div className="overflow-hidden px-4 sm:px-8 md:px-12 lg:px-16 py-4">
            <div
              className="flex -mx-3 transition-transform duration-1000 ease-in-out"
              style={{
                transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)`,
              }}
            >
              {PARTNERS.map((partner, index) => {
                const CardContent = (
                  <>
                    {/* Image Area (45% height) */}
                    <div className="h-[45%] w-full bg-white flex items-center justify-center overflow-hidden border-b border-stone-100/50 shrink-0">
                      <img
                        src={partner.image}
                        alt={partner.title}
                        className={`transition-transform duration-500 ${
                          partner.link ? "group-hover:scale-105" : ""
                        } ${
                          partner.isLogo
                            ? "object-contain max-h-[88%] max-w-[88%] p-1"
                            : "object-cover h-full w-full"
                        }`}
                      />
                    </div>
                    {/* Content Area (55% height) */}
                    <div className={`h-[55%] p-4 flex flex-col justify-between items-center text-center bg-stone-100/60 ${
                      partner.link ? "group-hover:bg-stone-100" : ""
                    } transition-colors duration-300`}>
                      <div className="flex-1 flex flex-col items-center justify-start pt-2 space-y-1.5 h-fit">
                        <span className="text-brand-dark font-bold text-base tracking-tight block">
                          {partner.title}
                        </span>
                        {partner.description && (
                          <p className="text-stone-500 text-xs leading-relaxed font-normal whitespace-pre-line max-w-[95%]">
                            {partner.description}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center mt-2 shrink-0">
                        {partner.link && (
                          <div className="h-9 w-9 rounded-full bg-white flex items-center justify-center text-brand-dark shadow-sm group-hover:bg-brand-primary group-hover:text-white transition-all duration-300 shrink-0">
                            <ArrowUpRight className="h-4.5 w-4.5" />
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                );

                const cardClass = "aspect-[4/4.4] flex flex-col rounded-[2rem] overflow-hidden bg-stone-100/60 hover:bg-stone-100 transition-all duration-300 hover:-translate-y-1.5 group shadow-sm hover:shadow-md h-full w-full";
                const staticCardClass = "aspect-[4/4.4] flex flex-col rounded-[2rem] overflow-hidden bg-stone-100/60 shadow-sm h-full w-full";

                return (
                  <div
                    key={index}
                    className="px-3 shrink-0"
                    style={{ width: `${100 / visibleSlides}%` }}
                  >
                    {!partner.link ? (
                      <div className={staticCardClass}>
                        {CardContent}
                      </div>
                    ) : partner.isExternal ? (
                      <a
                        href={partner.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={cardClass}
                      >
                        {CardContent}
                      </a>
                    ) : (
                      <Link
                        to={partner.link}
                        className={cardClass}
                      >
                        {CardContent}
                      </Link>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Navigation Buttons */}
          {PARTNERS.length > visibleSlides && (
            <>
              <button
                onClick={prevSlide}
                className="absolute left-4 lg:left-6 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-stone-50 text-brand-dark hover:text-brand-primary h-12 w-12 rounded-full shadow-lg border border-stone-200 flex items-center justify-center transition-all duration-200 cursor-pointer"
                aria-label="Forrige"
              >
                <ChevronLeft className="h-6 w-6" />
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 lg:right-6 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-stone-50 text-brand-dark hover:text-brand-primary h-12 w-12 rounded-full shadow-lg border border-stone-200 flex items-center justify-center transition-all duration-200 cursor-pointer"
                aria-label="Næste"
              >
                <ChevronRight className="h-6 w-6" />
              </button>
            </>
          )}
        </div>
      </section>

      {/* Passed Students Section */}
      {passedStudents && passedStudents.length > 0 && (() => {
        const extendedStudents = [...passedStudents, ...passedStudents, ...passedStudents];
        const scrollToContact = (e) => {
          e.preventDefault();
          const element = document.getElementById("kontakt-sektion");
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          } else {
            window.location.href = "/kontakt";
          }
        };

        return (
          <section className="py-20 lg:py-28 bg-stone-50 border-b border-stone-200 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center max-w-3xl mx-auto mb-16">
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
                  Glade elever
                </span>
                <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-brand-dark tracking-tight">
                  De har bestået deres kørekort!
                </h2>
                <p className="text-stone-600 text-sm sm:text-base mt-4 leading-relaxed">
                  Stort tillykke til mine fantastiske elever, som har kæmpet hårdt og nu har fået det eftertragtede lyserøde kort. Her er et lille udpluk af de seneste glade bilister.
                </p>
              </div>

              <div 
                className="relative w-full"
                onMouseEnter={() => setStudentIsPaused(true)}
                onMouseLeave={() => setStudentIsPaused(false)}
              >
                {/* Carousel track wrapper */}
                <div className="overflow-hidden px-2 sm:px-8 md:px-12 lg:px-16 py-4">
                  <div
                    className={`flex -mx-3 ${
                      studentIsTransitioning ? "transition-transform duration-700 ease-in-out" : "transition-none"
                    }`}
                    style={{
                      transform: `translateX(-${studentIndex * (100 / studentVisibleSlides)}%)`,
                    }}
                    onTransitionEnd={handleStudentTransitionEnd}
                  >
                    {extendedStudents.map((student, index) => {
                      const imageUrl = student.image?.[0];
                      const optimizedImage = getOptimizedUrl(imageUrl, 600);
                      return (
                        <div
                          key={`${student.id}-${index}`}
                          className="px-3 shrink-0 flex flex-col"
                          style={{ width: `${100 / studentVisibleSlides}%` }}
                        >
                          <div className="bg-white rounded-[2rem] overflow-hidden shadow-sm hover:shadow-md border border-stone-200/60 transition-all duration-300 hover:-translate-y-1.5 group flex flex-col h-full">
                            <div className="aspect-[4/5] overflow-hidden relative bg-stone-100 shrink-0">
                              {imageUrl ? (
                                <img
                                  src={optimizedImage}
                                  alt={`Glade elev ${student.name}`}
                                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                                  loading="lazy"
                                />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center text-stone-400">
                                  <Users className="h-12 w-12" />
                                </div>
                              )}
                              
                              {/* Overlay with Name and Passed Date */}
                              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-stone-950/90 via-stone-950/40 to-transparent p-6 pt-12 flex flex-col justify-end">
                                <h3 className="font-bold text-white text-xl tracking-tight">
                                  {student.name}
                                </h3>
                                {student.passed_date && (
                                  <span className="text-stone-300 text-xs mt-1 font-medium">
                                    Bestået {student.passed_date}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {/* Navigation Buttons */}
                {passedStudents.length > studentVisibleSlides && (
                  <>
                    <button
                      onClick={prevStudentSlide}
                      className="absolute left-0 sm:left-2 lg:left-4 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-stone-50 text-brand-dark hover:text-brand-primary h-12 w-12 rounded-full shadow-lg border border-stone-200 flex items-center justify-center transition-all duration-200 cursor-pointer"
                      aria-label="Forrige"
                    >
                      <ChevronLeft className="h-6 w-6" />
                    </button>
                    <button
                      onClick={nextStudentSlide}
                      className="absolute right-0 sm:right-2 lg:right-4 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-stone-50 text-brand-dark hover:text-brand-primary h-12 w-12 rounded-full shadow-lg border border-stone-200 flex items-center justify-center transition-all duration-200 cursor-pointer"
                      aria-label="Næste"
                    >
                      <ChevronRight className="h-6 w-6" />
                    </button>
                  </>
                )}

                {/* Dots Indicators */}
                {passedStudents.length > studentVisibleSlides && (
                  <div className="flex justify-center gap-2 mt-6">
                    {Array.from({ length: passedStudents.length }).map((_, i) => {
                      const isActive = (studentIndex % passedStudents.length) === i;
                      return (
                        <button
                          key={i}
                          onClick={() => {
                            if (!studentIsTransitioning) return;
                            setStudentIndex(passedStudents.length + i);
                          }}
                          className={`h-2.5 rounded-full transition-all duration-300 ${
                            isActive ? "w-8 bg-brand-primary" : "w-2.5 bg-stone-300 hover:bg-stone-400"
                          }`}
                          aria-label={`Gå til slide ${i + 1}`}
                        />
                      );
                    })}
                  </div>
                )}

                {/* Action Buttons Below Slider */}
                <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-12 px-4">
                  <a
                    href="#kontakt-sektion"
                    onClick={scrollToContact}
                    className="w-full sm:w-auto px-8 py-4 bg-brand-primary text-white text-base font-bold rounded-xl shadow-md hover:bg-brand-primary-hover hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <Award className="h-5 w-5" />
                    Få dit nu
                  </a>
                  <a
                    href="https://www.facebook.com/carinaskoereskole.dk/?locale=da_DK"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full sm:w-auto px-8 py-4 bg-[#1877F2] text-white text-base font-bold rounded-xl shadow-md hover:bg-[#166FE5] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2 cursor-pointer"
                  >
                    <Facebook className="h-5 w-5" />
                    Følg med på Facebook
                  </a>
                </div>
              </div>
            </div>
          </section>
        );
      })()}

      {/* Contact Section */}
      <section id="kontakt-sektion" className="py-16 lg:py-24 bg-brand-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Contact Info */}
            <div className="lg:col-span-5 space-y-8">
              <div>
                <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-primary/10 text-brand-primary text-xs font-bold uppercase tracking-wider mb-4">
                  Kontakt os
                </span>
                <h2 className="text-3xl sm:text-4xl font-black text-brand-dark tracking-tight">
                  Klar til at starte?
                </h2>
                <p className="text-stone-600 text-sm sm:text-base mt-4 leading-relaxed">
                  Har du spørgsmål til holdstart, priser, automatgear eller andet? Du er altid velkommen til at ringe, sende en SMS eller skrive en mail.
                </p>
              </div>

              <div className="space-y-4">
                <div className="bg-white p-5 rounded-2xl border border-stone-200 shadow-sm flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                    <MapPin className="h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-brand-dark text-sm">Teorilokale adresse</h4>
                    <p className="text-stone-600 text-sm mt-1">Gugvej 186 D, kld. tv., 9210 Aalborg SØ</p>
                    <span className="text-stone-400 text-xs block mt-1">(Bus nr. 15 holder lige ved døren)</span>
                  </div>
                </div>

                <div className="bg-white p-5 rounded-2xl border border-stone-200 shadow-sm flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-brand-primary/10 text-brand-primary flex items-center justify-center shrink-0">
                    <Smile className="h-5 w-5" />
                  </div>
                  <div>
                    <h4 className="font-bold text-brand-dark text-sm">Ring eller SMS</h4>
                    <a href="tel:30517269" className="text-brand-primary font-bold text-lg hover:underline block mt-1">
                      30 51 72 69
                    </a>
                    <span className="text-stone-400 text-xs block mt-0.5">Send gerne en SMS med dit navn, så kontakter jeg dig hurtigst muligt.</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
